


// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// const menuItems = [
//    { id: "ctrl", label: "통합관제", className: "ctrl", path: "/dashboard/integratedControlView" },
//    { id: "trfFlow", label: "도로소통", className: "trfFlow", path: "/dashboard/roadTrafficView" },
//    { id: "sfty", label: "교통안전", className: "sfty", path: "/dashboard/trafficSafetyView" },
//    { id: "sgnl", label: "신호운영", className: "sgnl", path: "/dashboard/signalOperationView" },
//    { id: "bus", label: "버스운행", className: "bus", path: "/dashboard/busOperationView" },
//    { id: "future", label: "미래교통", className: "future", path: "/dashboard/futureTransportationView" },
// ];

// const SidebarMenu = () => {
//    const navigate = useNavigate();
//    const location = useLocation();

//    // 현재 경로에 맞는 메뉴 ID 찾기
//    const getCurrentMenuId = () => {
//      const currentPath = location.pathname;
//      const currentMenu = menuItems.find(item => item.path === currentPath);
//      return currentMenu ? currentMenu.id : "ctrl"; // 기본값
//    };

//    const [activeMenu, setActiveMenu] = useState(getCurrentMenuId());

//    const handleMenuClick = (item) => {
//      setActiveMenu(item.id);
//      navigate(item.path);
//    };

//    return (
//      <div className="lnb">
//        {menuItems.map((item) => (
//          <div 
//            key={item.id} 
//            className={`dep1 ${item.className} ${activeMenu === item.id ? 'on' : ''}`}
//            onClick={() => handleMenuClick(item)}
//            style={{ cursor: 'pointer' }}
//          >
//            <div className="imgBox"></div>
//            <p>{item.label}</p>
//          </div>
//        ))}
//      </div>
//    );
// };

// export default SidebarMenu;

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDashboard } from "../components/DashboardContext";

const menuItems = [
  {
    id: "ctrl",
    label: "통합관제",
    className: "ctrl",
    path: "/dashboard/integratedControlView",
    viewType: "integratedControl"
  },
  {
    id: "trfFlow",
    label: "교통정보",
    className: "trfFlow",
    path: "/dashboard/roadTrafficView",
    viewType: "roadTraffic"
  },
  {
    id: "sgnl",
    label: "신호운영",
    className: "sgnl",
    path: "/dashboard/signalOperationView",
    viewType: "SignalOperationViewTest"
  },
  {
    id: "bus",
    label: "버스운행",
    className: "bus",
    path: "/dashboard/busOperationView",
    viewType: "busOperation"
  },
  {
    id: "sfty",
    label: "교통안전",
    className: "sfty",
    path: "/dashboard/trafficSafetyView",
    viewType: "trafficSafety"
  },
  {
    id: "future",
    label: "미래교통",
    className: "future",
    path: "/dashboard/futureTransportationView",
    viewType: "futureTransportation"
  },
];
const SidebarMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setActiveView, sendMessageToMap } = useDashboard();
  const { mapMessages } = useDashboard();
  const { latestMapMessage } = useDashboard();
  // 현재 활성 메뉴 ID 확인
  const getCurrentMenuId = () => {
    const currentPath = location.pathname;
    const currentMenu = menuItems.find(item => item.path === currentPath);
    return currentMenu ? currentMenu.id : "ctrl";
  };

  const [activeMenu, setActiveMenu] = useState(getCurrentMenuId());

  const handleMenuClick = (item) => {
    setActiveMenu(item.id);
    setActiveView(item.viewType);
    sendMessageToMap(`VIEW_CHANGED:${item.viewType}`);
    navigate(item.path);
  };

  // 다른 창에서 변경된 경우 activeMenu 업데이트
  const { activeView } = useDashboard();
  React.useEffect(() => {
    if (!latestMapMessage) return;

    if (latestMapMessage.startsWith("VIEW_CHANGED:")) {
      const [, viewType] = latestMapMessage.split(":");
      const matchedMenu = menuItems.find(item => item.viewType === viewType);
      if (matchedMenu) {
        navigate(matchedMenu.path);
      }
    }
  }, [latestMapMessage]);

  useEffect(() => {
    const currentId = menuItems.find(item => item.viewType === activeView)?.id;
    if (currentId) setActiveMenu(currentId);
  }, [activeView]);



  return (
    <div className="lnb">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={`dep1 ${item.className} ${activeMenu === item.id ? 'on' : ''}`}
          onClick={() => handleMenuClick(item)}
          style={{ cursor: 'pointer' }}
        >
          <div className="imgBox"></div>
          <p>{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default SidebarMenu;